import{__assign as r}from"../../_virtual/_tslib.js";var a={flex:1,bg:"secondaryDark",borderRadius:4},e={primary:r(r({},a),{p:4,dark:r(r({},a),{p:4,bg:"secondaryDarker"})}),compact:r(r({},a),{p:0,dark:r(r({},a),{p:0,bg:"secondaryDarker"})})};export{e as card};
//# sourceMappingURL=card.js.map
